var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalProductSaleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.936279,
    width: 33.0638,
    height: 33.0638,
    rx: 7.34752,
    fill: "#7459AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4683 26.2621C16.7723 26.4377 17.1172 26.5301 17.4683 26.5301C17.8193 26.5301 18.1642 26.4377 18.4683 26.2621L25.4683 22.2621C25.772 22.0868 26.0243 21.8346 26.1998 21.531C26.3753 21.2273 26.4679 20.8829 26.4683 20.5321V12.5321C26.4679 12.1814 26.3753 11.8369 26.1998 11.5333C26.0243 11.2296 25.772 10.9775 25.4683 10.8021L18.4683 6.80213C18.1642 6.62659 17.8193 6.53418 17.4683 6.53418C17.1172 6.53418 16.7723 6.62659 16.4683 6.80213L9.46826 10.8021C9.16452 10.9775 8.91224 11.2296 8.73672 11.5333C8.5612 11.8369 8.46862 12.1814 8.46826 12.5321V20.5321C8.46862 20.8829 8.5612 21.2273 8.73672 21.531C8.91224 21.8346 9.16452 22.0868 9.46826 22.2621L16.4683 26.2621Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4683 26.5322V16.5322",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7583 11.5322L17.4683 16.5322L26.1783 11.5322",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9683 8.80176L21.9683 13.9518",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProductSaleIcon);
export default __webpack_public_path__ + "static/media/total-product-sale-icon.510a8078b0511a2e78401a702eb5f380.svg";
export { ForwardRef as ReactComponent };